module.exports = __webpack_public_path__ + "img/Clouds.94c248bb.svg";